import React, { useState, useEffect } from 'react'

//* Api
import { updateCart } from 'api/woocommerce'

//* Translations
import strings from 'translations/strings.json'

//* Components
import { ToCheckoutLoader } from '../../../../../Loader/Loaders'

//* Styles
import styles from './CartActions.module.scss'

const CartActions = () => {

    
    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

    const [ { isLoaderActive }, setIsLoaderActive ] = useState({ isLoaderActive: false })
    
    useEffect(() => {
        if(isLoaderActive === true){
          setIsLoaderActive({ isLoaderActive: false })
        }
      }, [])

    async function goToCheckout(){

        setIsLoaderActive({ isLoaderActive: true })
        await updateCart()
            .then(() => {
                setTimeout(() => {
                    setIsLoaderActive({ isLoaderActive: false })
                }, 2000);
            })
        
    }

  return (
    <div className={styles["cart-actions"]}>
        {
            isLoaderActive === true ? <ToCheckoutLoader/> : null
        }
        <button className={`${styles["btn"]} ${styles["filo-primary"]}`}
            onClick={() => goToCheckout()}
        >
            { STRINGS_LANG.checkout }
        </button>
    </div>
  )
}

export default CartActions